import { Component, ViewChild, ElementRef, AfterViewInit, Injector, Output, EventEmitter} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { PayGradeDetailsesServiceProxy, CreateOrEditPayGradeDetailsDto, PayGradesServiceProxy, DropDown, CreateOrEditPayGradeDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import * as moment from 'moment';
import { PayGradeDetailsPayGradeLookupTableModalComponent } from './payGradeDetails-payGrade-lookup-table-modal.component';
import { PayGradeDetailsPayComponetsLookupTableModalComponent } from './payGradeDetails-payComponets-lookup-table-modal.component';
import { PayComponentSetValueComponent } from '../pay-component-set-value/pay-component-set-value.component';

@Component({
    selector: 'createOrEditPayGradeDetailsModal',
    templateUrl: './create-or-edit-payGradeDetails-modal.component.html'
})
export class CreateOrEditPayGradeDetailsModalComponent extends AppComponentBase implements AfterViewInit {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @ViewChild('payGradeDetailsPayGradeLookupTableModal', { static: true }) payGradeDetailsPayGradeLookupTableModal: PayGradeDetailsPayGradeLookupTableModalComponent;
    @ViewChild('payGradeDetailsPayComponetsLookupTableModal', { static: true }) payGradeDetailsPayComponetsLookupTableModal: PayGradeDetailsPayComponetsLookupTableModalComponent;
    @ViewChild('payComponentSetValue', { static: true }) payComponentSetValue: PayComponentSetValueComponent;
    @ViewChild('calcListContainer', { static: false }) calcListContainer: ElementRef;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Output() onMovetoSource: EventEmitter<any> = new EventEmitter(); 
    @Output() onTargetSelect: EventEmitter<any> = new EventEmitter(); 
    active = false;
    saving = false;
    sourceProducts: DropDown[];
    
    targetProducts: DropDown[];

    payGradeDetails: CreateOrEditPayGradeDto = new CreateOrEditPayGradeDto();
    payGradeDetailList: Array<CreateOrEditPayGradeDetailsDto> = new Array<CreateOrEditPayGradeDetailsDto>();
    payGradeDetailWithValueList: Array<CreateOrEditPayGradeDetailsDto> = new Array<CreateOrEditPayGradeDetailsDto>();
    payDetail:CreateOrEditPayGradeDetailsDto=new CreateOrEditPayGradeDetailsDto();
    payGradeName = '';
    payComponetsName = '';
    payGradeIds:number;
    paygradesource:string="";

    calculationTypeOptions: any[] = [
        { label: '% of Gross', value: 'A' },
        { label: '% of CTC', value: 'B' },
        { label: 'Fixed', value: 'C' },
    ];
    calcValues: { [id: number]: { calculationType: string; value: string } } = {};
    calcSearch = '';
    selectedCalcId: number | null = null;

    get filteredTargetProducts(): DropDown[] {
        if (!this.targetProducts) { return []; }
        const q = (this.calcSearch || '').trim().toLowerCase();
        if (!q) { return this.targetProducts; }
        return this.targetProducts.filter(p => (p.label || '').toLowerCase().includes(q));
    }
addControlSheetItem(event: any): void {
    console.log(event);
// Your logic here
}
    isPfOrEsi(label: string): boolean {
        const l = (label || '').trim().toLowerCase();
        return l === 'pf' || l === 'esi';
    }

    getCalcEntry(id: number) {
        if (!this.calcValues[id]) {
            this.calcValues[id] = { calculationType: 'A', value: '' };
        }
        return this.calcValues[id];
    }

    onCalcValueInput(id: number, val: string) {
        const cleaned = (val || '').replace(/[^0-9.]/g, '');
        this.getCalcEntry(id).value = cleaned;
    }

    selectCalcRow(id: number): void {
        this.selectedCalcId = id;
    }

    private targetIndexOf(id: number): number {
        return this.targetProducts ? this.targetProducts.findIndex(p => p.value === id) : -1;
    }

    moveSelectedCalc(direction: 'up' | 'down' | 'top' | 'bottom'): void {
        if (this.selectedCalcId == null || !this.targetProducts) { return; }
        const i = this.targetIndexOf(this.selectedCalcId);
        if (i < 0) { return; }
        const arr = [...this.targetProducts];

        if (direction === 'up' && i > 0) {
            [arr[i - 1], arr[i]] = [arr[i], arr[i - 1]];
        } else if (direction === 'down' && i < arr.length - 1) {
            [arr[i + 1], arr[i]] = [arr[i], arr[i + 1]];
        } else if (direction === 'top' && i > 0) {
            const [item] = arr.splice(i, 1);
            arr.unshift(item);
        } else if (direction === 'bottom' && i < arr.length - 1) {
            const [item] = arr.splice(i, 1);
            arr.push(item);
        } else {
            return;
        }

        this.targetProducts = arr;
    }



    private targetListEl: HTMLElement;
    private targetScrollHandler = (e: Event) => {
        if (!this.calcListContainer || !this.targetProducts || this.targetProducts.length === 0) { return; }
        const targetEl = e.target as HTMLElement;
        const calcEl: HTMLElement = this.calcListContainer.nativeElement;
        const itemCount = this.targetProducts.length;
        const targetRowHeight = targetEl.scrollHeight / itemCount;
        const calcRowHeight = calcEl.scrollHeight / itemCount;
        if (!targetRowHeight || !calcRowHeight) { return; }
        // Match by item index rather than raw pixel offset, since the two lists use different row heights.
        const index = targetEl.scrollTop / targetRowHeight;
        calcEl.scrollTop = index * calcRowHeight;
    }

    constructor(
        injector: Injector,
        private elementRef: ElementRef,
        private _payGradeDetailsesServiceProxy: PayGradeDetailsesServiceProxy,
        private _payGradesServiceProxy: PayGradesServiceProxy
    ) {
        super(injector);
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.bindTargetScrollSync());
    }

    private bindTargetScrollSync(): void {
        if (this.targetListEl) {
            this.targetListEl.removeEventListener('scroll', this.targetScrollHandler);
        }
        const el = this.elementRef.nativeElement.querySelector('.p-picklist-target-wrapper .p-picklist-list');
        if (el) {
            this.targetListEl = el;
            this.targetListEl.addEventListener('scroll', this.targetScrollHandler);
        }
    }

    show(payGradesId?:number,payGradeDetailsId?: number): void {
            this.payGradeDetails = new CreateOrEditPayGradeDto();
            this.payGradeDetails.id = payGradeDetailsId;
            this.payGradeIds=payGradesId;
            this.calcValues = {};
        this._payGradeDetailsesServiceProxy.getPayGradeDetailsForEdit(payGradesId).subscribe(result => {
        this.payGradeDetails = result;

        if(this.payGradeDetails.payGradeDetails.length>0)
        {
            this.payGradeDetails.saveType="E";
        }
        else
        {
            this.payGradeDetails.saveType="A";
        }
        for(let i=0;i<result.payGradeDetails.length;i++)
        {
            this.payDetail=new CreateOrEditPayGradeDetailsDto();
            this.payDetail.calculationType=this.payGradeDetails.payGradeDetails[i].calculationType;
            this.payDetail.amount=parseFloat(this.payGradeDetails.payGradeDetails[i].amount.toString());
            this.payDetail.formulaString=this.payGradeDetails.payGradeDetails[i].formulaString||"";
            this.payDetail.payComponetId=this.payGradeDetails.payGradeDetails[i].payComponetId;
            this.payDetail.payGradeId=this.payGradeDetails.payGradeDetails[i].payGradeId;
            this.payDetail.sequence=this.payGradeDetails.payGradeDetails[i].sequence;
            this.payGradeDetailWithValueList.push(this.payDetail);
            this.calcValues[this.payDetail.payComponetId] = {
                calculationType: this.payDetail.calculationType || 'A',
                value: this.payDetail.formulaString || ''
            };
        }
        if(this.payGradeDetails.payGradeDetails.length>0)
        {
                this.paygradesource="";
                for(let i=0;i<this.payGradeDetails.payGradeDetails.length;i++)
                {
                    this.paygradesource=this.paygradesource==""?this.payGradeDetails.payGradeDetails[i].payComponetId.toString():this.paygradesource+","+this.payGradeDetails.payGradeDetails[i].payComponetId;
                }
                    this._payGradesServiceProxy.getPayComponentSource(this.paygradesource).subscribe(products =>
                    this.sourceProducts = products);
                    this._payGradesServiceProxy.getPayComponentTarget(this.paygradesource,this.payGradeIds).subscribe(products =>
                    this.targetProducts = products);
        }
        else
        {
            this._payGradesServiceProxy.getPayComponent().subscribe(products =>
            this.sourceProducts = products);
            this.targetProducts = [];
        }
      });
  
       

        this.active = true;
        this.modal.show();
        setTimeout(() => this.bindTargetScrollSync(), 300);

    }
    setPayComponentValue(event)
    {
        for(let i=0;i<event.items.length;i++)
        {
            this.getCalcEntry(event.items[i].value);
        }
    }

    save(): void {
            this.saving = true;
            this.payGradeDetailList=new Array<CreateOrEditPayGradeDetailsDto>();
            for(var i=0;i<this.targetProducts.length;i++)
            {
                let paydetails=new CreateOrEditPayGradeDetailsDto();
                paydetails.payComponetId=this.targetProducts[i].value;
                paydetails.payGradeId=this.payGradeIds;
                paydetails.amount=0;
                paydetails.sequence=i+1;

                if(this.isPfOrEsi(this.targetProducts[i].label))
                {
                    paydetails.calculationType="";
                    paydetails.formulaString="";
                }
                else
                {
                    const entry = this.getCalcEntry(Number(this.targetProducts[i].value));
                    paydetails.calculationType=entry.calculationType;
                    paydetails.formulaString=entry.value;
                }
               this.payGradeDetailList.push(paydetails);
            }
            this.payGradeDetails.payGradeDetails=this.payGradeDetailList;
         
            if(this.payGradeDetails.saveType=="E")
            {
                this.payGradeDetails.id=this.payGradeIds;
            }
            this._payGradeDetailsesServiceProxy.createOrEdit(this.payGradeDetails)
             .pipe(finalize(() => { this.saving = false;}))
             .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
             });
    }

    openSelectPayGradeModal() {
        //this.payGradeDetailsPayGradeLookupTableModal.id = this.payGradeDetails.payGradeId;
        this.payGradeDetailsPayGradeLookupTableModal.displayName = this.payGradeName;
        this.payGradeDetailsPayGradeLookupTableModal.show();
    }
    openSelectPayComponetsModal() {
       // this.payGradeDetailsPayComponetsLookupTableModal.id = this.payGradeDetails.payComponetsId;
        this.payGradeDetailsPayComponetsLookupTableModal.displayName = this.payComponetsName;
        this.payGradeDetailsPayComponetsLookupTableModal.show();
    }


    setPayGradeIdNull() {
        //this.payGradeDetails.payGradeId = null;
        this.payGradeName = '';
    }
    setPayComponetsIdNull() {
        //this.payGradeDetails.payComponetsId = null;
        this.payComponetsName = '';
    }


    getNewPayGradeId() {
        //this.payGradeDetails.payGradeId = this.payGradeDetailsPayGradeLookupTableModal.id;
        this.payGradeName = this.payGradeDetailsPayGradeLookupTableModal.displayName;
    }
    getNewPayComponetsId() {
        //this.payGradeDetails.payComponetsId = this.payGradeDetailsPayComponetsLookupTableModal.id;
        this.payComponetsName = this.payGradeDetailsPayComponetsLookupTableModal.displayName;
    }


    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
